<template>
  <div v-if="type">
    <h1>Type</h1>
    <v-btn :to="{ name: 'entityTypes' }">
      <v-icon>chevron_left</v-icon>Types
    </v-btn>
    <v-form ref="formType" v-model="valid" lazy-validation>
      <v-text-field
        label="Id"
        v-model="type.id"
        v-if="computedEditing"
        outline
        readonly
      />
      <v-text-field
        label="Name"
        v-model="type.name"
        :rules="valueRules"
        :readonly="computedEditing"
        outline
      />
      <v-checkbox label="Contact" v-model="type.contact" />
      <v-checkbox label="Security" v-model="type.security" />
      <v-checkbox label="Person" v-model="type.person" />
      <v-checkbox label="Company" v-model="type.company" />
      <v-checkbox label="Staff" v-model="type.staff" />
      <v-select
        label="Address"
        v-model="type.address"
        :items="addressTypes"
        item-value="id"
        item-text="body"
        outline
      />
      <v-checkbox label="Groups" v-model="type.groups" />
      <v-checkbox label="Employees" v-model="type.employees" />
      <v-checkbox label="Allow many" v-model="type.allowMany" />
      <h3>Entry search</h3>
      <v-checkbox label="Allow entry add" v-model="type.entrySearchAllow" />
      <v-checkbox
        label="Show search box by default"
        v-model="type.entrySearchSearch"
      />
      <v-checkbox
        label="Can create a new entry"
        v-model="type.entrySearchAdd"
      />
      <v-btn @click="saveType"> <v-icon>save</v-icon>Save </v-btn>
    </v-form>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Type",
  metaInfo() {
    return {
      title: "Type",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedEditing() {
      return this.$route.params.id ? true : false;
    }
  },
  data() {
    return {
      type: null,
      valid: false,
      valueRules: [(v) => !!v || "Value is required"],
      addressTypes: [
        { id: 0, body: "0" },
        { id: 1, body: "1" },
        { id: 2, body: "2" }
      ]
    };
  },
  methods: {
    fetchType() {
      nbmlaw
        .get(`/cors/admin/directory/types/${this.$route.params.id}`)
        .then((response) => {
          // console.log(response.data);
          this.type = response.data;
        })
        .catch(() => {});
    },
    saveType() {
      if (this.$refs.formType.validate()) {
        if (this.$route.params.id) {
          this.updateType();
        } else {
          this.createType();
        }
      }
    },
    updateType() {
      nbmlaw
        .put(`/cors/admin/directory/types/${this.$route.params.id}`, this.type)
        .then(() => {
          this.$router.push({ name: "entityTypes" });
        })
        .catch(() => {});
    },
    createType() {
      nbmlaw
        .post(`/cors/admin/directory/types`, this.type)
        .then(() => {
          this.$router.push({ name: "entityTypes" });
        })
        .catch(() => {});
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchType();
        } else {
          this.type = { address: 0 };
        }
      }
    }
  }
};
</script>
